import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { generateQueryParams } from '../../../../search/utils';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../../search-new/context/SearchContext';

const Header = () => {
  const { t } = useTranslation(['map', 'launches']);

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const { searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;

  return (
    <HeaderContainer>
      <h3 className="header">{t('available_properties')}</h3>

      <Link
        href={`/compound/${selectedCompound?.id}?${generateQueryParams(
          searchFiltersState.searchFilters
        )}`}
        className="show-all"
        target="_blank"
        prefetch={false}
      >
        {t('show_all', { ns: 'launches' })}
      </Link>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header {
    color: #2c3138;
    font-size: 16px;
    font-family: materialBold;
  }

  .show-all {
    color: #015c9a;
    font-size: 14px;
    font-family: materialMedium;
    text-decoration: underline;
  }
`;

export default Header;
